import { AsyncPipe, TitleCasePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { RouterLink } from '@angular/router'

import { filter, map, takeUntil, tap } from 'rxjs'

import { DestroyDirective } from '~/core/directives'
import { CompanyFacade } from '~/core/features'
import { LoadingComponent } from '~/ui/loading'

@Component({
  selector: 'app-comparable-companies-container',
  templateUrl: './comparable-companies-container.component.html',
  styleUrl: './comparable-companies-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [AsyncPipe, RouterLink, TitleCasePipe, MatCardModule, LoadingComponent],
})
export class ComparableCompaniesContainerComponent implements OnInit {
  private readonly destroy$ = inject(DestroyDirective).destroy$

  readonly companyFacade = inject(CompanyFacade)

  constructor() {}

  ngOnInit(): void {
    this.companyFacade.forecast$
      .pipe(
        filter(forecast => Boolean(forecast)),
        map(forecast => forecast!.company.companyId),
        tap(companyId => this.companyFacade.getComparableCompanies(companyId)),
        takeUntil(this.destroy$)
      )
      .subscribe()
  }
}
